export enum DashboardButtonEnum {
  CAMERA_BUTTON = 'CAMERA_BUTTON',
  MIC_BUTTON = 'MIC_BUTTON',
  CHAT_BUTTON = 'CHAT_BUTTON',
  PARTICIPANTS_BUTTON = 'PARTICIPANTS_BUTTON',
  VIEW_TOGGLE_BUTTON = 'VIEW_TOGGLE_BUTTON',
  RISE_HAND_BUTTON = 'RISE_HAND_BUTTON',
  SCREEN_SHARE_BUTTON = 'SCREEN_SHARE_BUTTON',
  TELEPORT_BUTTON = 'TELEPORT_BUTTON',
  ASSISTANT_BUTTON = 'ASSISTANT_BUTTON',
  TOOLS_BUTTON = 'TOOLS_BUTTON',
  ACTIONS_BUTTON = 'ACTIONS_BUTTON',
}
